import types from '../../types';

const margin = (
  state = { loading: true, repayment: null, transfer: null, history: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_MARGIN_HISTORY_SUCCESS:
      return { ...state, history: payload, loading: false };

    case types.GET_MARGIN_REPAYMENT_SUCCESS:
      return { ...state, repayment: payload, loading: false };

    case types.GET_MARGIN_TRANSFERS_SUCCESS:
      return { ...state, transfer: payload, loading: false };

    case types.GET_MARGIN_HISTORY_START:
    case types.GET_MARGIN_REPAYMENT_START:
    case types.GET_MARGIN_TRANSFERS_START:
      return { ...state, loading: true };

    case types.GET_MARGIN_HISTORY_FAILURE:
    case types.GET_MARGIN_REPAYMENT_FAILURE:
    case types.GET_MARGIN_TRANSFERS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default margin;
